const faqInit = (block) => {
    console.log('ok');
    const faq = block ? block[0].querySelector(".bn-faq") : document.querySelector('.bn-faq');
    if (faq) {
        [...faq.querySelectorAll('.bn-faq__tab')].forEach(el => {
            el.addEventListener('click', (e) => { //add listener for every tab
                e.currentTarget.classList.toggle('--open');
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        faqInit();
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/faq', faqInit);
});